/** Theme-aware classes for daily quizzes and quiz management UI */

export const filterBarClass =
  "flex flex-wrap gap-4 items-center rounded-lg border border-border bg-card p-4 shadow-sm";

export const tablePanelClass =
  "rounded-lg border border-border bg-card shadow-sm overflow-hidden";

export const questionListClass =
  "border border-border rounded-lg max-h-48 overflow-y-auto bg-background";

export const questionListClassTall =
  "border border-border rounded-lg max-h-64 overflow-y-auto bg-background";

export const questionRowHover = "hover:bg-accent/50";

export const iconMuted = "text-muted-foreground";

export const textMuted = "text-muted-foreground";

const DIFFICULTY = {
  easy: "bg-green-500/15 text-green-800 dark:text-green-400 border-green-500/20",
  medium:
    "bg-amber-500/15 text-amber-800 dark:text-amber-400 border-amber-500/20",
  hard: "bg-red-500/15 text-red-800 dark:text-red-400 border-red-500/20",
  beginner:
    "bg-blue-500/15 text-blue-800 dark:text-blue-400 border-blue-500/20",
  intermediate:
    "bg-orange-500/15 text-orange-800 dark:text-orange-400 border-orange-500/20",
  advanced:
    "bg-purple-500/15 text-purple-800 dark:text-purple-400 border-purple-500/20",
};

export function difficultyBadgeClass(difficulty) {
  return (
    DIFFICULTY[difficulty] ||
    "bg-muted text-muted-foreground border-border"
  );
}

export function activeStatusBadgeClass(isActive) {
  return isActive
    ? "bg-green-500/15 text-green-800 dark:text-green-400 border-green-500/20"
    : "bg-muted text-muted-foreground border-border";
}
